// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

// Selectors
import { makeGetElementPixelPosition } from './selectors/elementPositionSelector';
import { getTranslationStyles } from '../utils/cssUtil';

// Styles
import './ElementPositioner.scss';

const mapStateToProps = () => createSelector(makeGetElementPixelPosition(), (elementPosition) => ({ elementPosition }));

const ElementPositioner = ({ children, elementPosition }) => (
    <div className="ElementPositioner" style={getTranslationStyles(elementPosition)}>
        {children}
    </div>
);

ElementPositioner.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    elementId: PropTypes.string.isRequired,
    element: PropTypes.object,
    elementPosition: PropTypes.object,
};

export default connect(mapStateToProps)(ElementPositioner);
